/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f1816d0d2a8bc6242a42117046bea71b5e3164cc";
